import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  width: "50",
  height: "33",
  viewBox: "0 0 50 33",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("rect", {
    width: "50",
    height: "33.333",
    fill: "#016FD0",
    rx: "4"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#FFFFFE",
    d: "M28.675 27.904V16.026l21.14.019v3.281l-2.443 2.611 2.444 2.635v3.351h-3.901l-2.074-2.288-2.058 2.297z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#016FD0",
    d: "M30.087 26.602v-9.269h7.859v2.135h-5.314v1.45h5.187v2.1h-5.187v1.423h5.314v2.16z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#016FD0",
    d: "M37.907 26.602l4.348-4.64-4.348-4.629h3.366l2.657 2.938 2.665-2.938h3.22v.073l-4.255 4.556 4.256 4.508v.132h-3.254l-2.704-2.967-2.677 2.967z"
  }), /*#__PURE__*/_jsx("path", {
    fill: "#FFFFFE",
    d: "M29.661 5.483h5.096l1.79 4.065V5.483h6.291l1.085 3.045 1.089-3.045h4.804v11.878H24.427z"
  }), /*#__PURE__*/_jsxs("g", {
    fill: "#016FD0",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M30.626 6.774l-4.113 9.26h2.821l.776-1.854h4.204l.775 1.854h2.891l-4.095-9.26h-3.259zm.353 5.328l1.234-2.948 1.232 2.948H30.98z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M37.942 16.033v-9.26l3.964.013 2.04 5.693L46 6.772h3.816v9.26l-2.456.023V9.693l-2.317 6.34H42.8l-2.366-6.361v6.36z"
    })]
  })]
});